
export const USER_MANAGEMENT_HEAD_CELLS = [
    { id: 'displayName', center: false, disablePadding: false, label: 'Name' },
    { id: 'username', center: false, disablePadding: false, label: 'Username' },
    { id: '', center: false, disablePadding: false, label: '' },
]

export const DEFAULT_SORT_BY_HEAD_CELL = 'name';
export const MANAGE_USERS_TITLE = 'Employees';

export const ROLE_DASHBOARD = "ROLE_DASHBOARD"
export const ROLE_MANAGE_USERS = "ROLE_MANAGE_USERS"
export const ROLE_MANAGE_FOLDER = "ROLE_MANAGE_FOLDER"




//settings
export const ROLE_SETTINGS = "ROLE_SETTINGS"

//Permission
export const ROLE_PERMISSIONS = "ROLE_PERMISSIONS"
export const ROLE_EDIT_ACCESS = "ROLE_EDIT_ACCESS"
export const ROLE_VIEW_ACCESS = "ROLE_VIEW_ACCESS"
export const ROLE_DELETE_ACCESS = "ROLE_DELETE_ACCESS"

export const ROLE_ACCOUNTING = "ROLE_ACCOUNTING"
export const ROLE_PROFITS = "ROLE_PROFITS"

export const ROLE_LIZ_ACCOUNTING = "ROLE_LIZ_ACCOUNTING"
export const ROLE_GAMEROOM_ACCOUNTING = "ROLE_GAMEROOM_ACCOUNTING"
export const ROLE_ATM = "ROLE_ATM"
export const ROLE_LOANS = "ROLE_LOANS"
export const ROLE_PROFIT_TRACKER = "ROLE_PROFIT_TRACKER"
export const ROLE_INVESTOR_TRACKER = "ROLE_INVESTOR_TRACKER"
export const ROLE_MASTER_INVESTOR_TRACKER = "ROLE_MASTER_INVESTOR_TRACKER"

export const ROLE_ADMIN = "ROLE_ADMIN"
export const ROLE_SUPERVISOR = "ROLE_SUPERVISOR"

export const PARENT_ROLE_MAP = {

     "ROLE_ACCOUNTING": [
        ROLE_PROFITS,
    ],

    "ROLE_LIZ_ACCOUNTING" :[
        ROLE_GAMEROOM_ACCOUNTING,
        ROLE_ATM,
    ],


    "ROLE_SETTINGS": [
        ROLE_MANAGE_FOLDER,
        ROLE_MANAGE_USERS,
    ],
    "ROLE_PERMISSIONS": [
        ROLE_VIEW_ACCESS,
        ROLE_EDIT_ACCESS,
        ROLE_DELETE_ACCESS,
    ],

    "ROLE_INVESTOR_TRACKER": [
        ROLE_MASTER_INVESTOR_TRACKER,
    ],
}

export const CHILD_ROLE_MAP = {

    "ROLE_PROFITS": [
        ROLE_ACCOUNTING
    ],

    "ROLE_GAMEROOM_ACCOUNTING": [
        ROLE_LIZ_ACCOUNTING
    ],
    "ROLE_ATM": [
        ROLE_LIZ_ACCOUNTING
    ],

    "ROLE_MANAGE_FOLDER": [
        ROLE_SETTINGS
    ],
    "ROLE_MANAGE_USERS": [
        ROLE_SETTINGS
    ],
    "ROLE_VIEW_ACCESS": [
        ROLE_PERMISSIONS
    ],
    "ROLE_EDIT_ACCESS": [
        ROLE_PERMISSIONS
    ],
    "ROLE_DELETE_ACCESS": [
        ROLE_PERMISSIONS
    ],

    "ROLE_MASTER_INVESTOR_TRACKER": [
        ROLE_INVESTOR_TRACKER
    ],
}

/**
 * Display-name overrides for the role checkbox list.
 * `getLabel(role)` falls back to titlecasing when there's no entry here.
 */
export const ROLE_LABEL_OVERRIDES = {
    "ROLE_TODO": "Task",
    "ROLE_PERMISSIONS": "File Manager - Permissions",
    "ROLE_GAMEROOM_ACCOUNTING": "GM Profits",
    "ROLE_ATM": "ATM Records",
    "ROLE_PROFIT_TRACKER": "Profit Tracker",
    "ROLE_INVESTOR_TRACKER": "Investor Tracker",
    "ROLE_MASTER_INVESTOR_TRACKER": "Investor Tracker - Master",
}

/**
 * Returns a copy of `allRoles` with ROLE_LOANS lifted into the
 * "File Manager - Permissions" group (immediately after ROLE_PERMISSIONS
 * + its child VIEW/EDIT/DELETE_ACCESS roles), so it visually sits with
 * the permissions block in the Edit Employee dialog.
 */
export const orderRolesForDisplay = (allRoles) => {
    if (!Array.isArray(allRoles)) return []

    // Pull ROLE_LOANS out of its current position.
    const loansIdx = allRoles.indexOf("ROLE_LOANS")
    if (loansIdx === -1) return allRoles.slice()

    const without = allRoles.filter(r => r !== "ROLE_LOANS")

    // Find the last "ROLE_PERMISSIONS" + its children, insert after them.
    const permissionsBlock = ["ROLE_PERMISSIONS", "ROLE_VIEW_ACCESS", "ROLE_EDIT_ACCESS", "ROLE_DELETE_ACCESS"]
    let insertAt = -1
    for (let i = without.length - 1; i >= 0; i -= 1) {
        if (permissionsBlock.includes(without[i])) {
            insertAt = i + 1
            break
        }
    }
    if (insertAt === -1) {
        // No permissions block in the response — just append loans.
        return [...without, "ROLE_LOANS"]
    }
    return [...without.slice(0, insertAt), "ROLE_LOANS", ...without.slice(insertAt)]
}

export const ROLE_DEPTH_AND_ORDER = {
    "ROLE_DASHBOARD": 0,
    "ROLE_TODO": 0,

    "ROLE_PERMISSIONS": 0,
    "ROLE_VIEW_ACCESS": 1,
    "ROLE_EDIT_ACCESS": 1,
    "ROLE_DELETE_ACCESS": 1,


    "ROLE_ACCOUNTING": 0,
    "ROLE_PROFITS": 1,

    "ROLE_LIZ_ACCOUNTING": 0,
    "ROLE_GAMEROOM_ACCOUNTING": 1,
    "ROLE_ATM": 1,

    "ROLE_LOANS": 0,

    "ROLE_PROFIT_TRACKER": 0,
    "ROLE_INVESTOR_TRACKER": 0,
    "ROLE_MASTER_INVESTOR_TRACKER": 1,

    "ROLE_SETTINGS": 0,
    "ROLE_MANAGE_FOLDER": 1,
    "ROLE_MANAGE_USERS": 1,
}

export const SELECT_COMPANY_SERVICES = 'Choose the services to grant to the company:';
export const SELECT_FOLDER_SERVICES = 'Choose the folders to grant access to:';
export const SELECT_SERVICES = 'Choose the services the employee can access:';
export const PASSWORD_ACTION = 'Generate Password';
export const PASSWORD_SUCCESS_MESSAGE = "Password successfully generated and copied to clipboard!";
export const EDIT_MESSAGE = "Editing ";
export const SAVE_ACTION = 'Save';
export const SAVING = 'Saving Changes...';
export const SAVE_SUCCESS_MESSAGE = "Employee info updated successfully!";
export const ERROR_MESSAGE = 'Error occurred processing request. Please try again.';

export const ERROR = 'error';
export const SUCCESS = 'success';
export const INFO = 'info';
export const WARNING = 'warning';

export const REGISTER_USER = "Register";
export const CANCEL = 'Cancel';

export const ACTIONS = {
    ADD: {
        title: "New Employee",
        description: "Add a employee to your team by entering their credentials. Make sure to save their initial password so they can access their account."
    }
}

export const ROWS_PER_PAGE_LABEL = "Results"
export const DEFAULT_ROWS_PER_PAGE = 50;

export const MANAGE_USERS_TOOLBAR_TITLE = "Manage Employee"
export const REGISTER_DIALOG_TITLE = "Register New Employee";
export const REGISTER_DIALOG_DESCRIPTION = "Fill out the information to add a employee to your team. Their password will be copied to your clipboard once you create the account."

export const DEFAULT = "Default"

export const TIME_ZONE = [
    'America/Chicago',
    'US/Aleutian',
    'US/Arizona',
    'US/Central',
    'US/East-Indiana',
    'US/Eastern',
    'US/Hawaii',
    'US/Indiana-Starke',
    'US/Michigan',
    'US/Mountain',
    'US/Pacific',
    'US/Pacific-New',
    'US/Samoa',
]